import { marked } from 'marked';

marked.setOptions({
  gfm: true,
  breaks: false,
});

/** Convert Markdown to HTML with heading IDs for in-page TOC anchors. */
export function renderMarkdown(markdown: string): string {
  const renderer = new marked.Renderer();

  renderer.heading = ({ text, depth }) => {
    const id = slugify(stripHtml(text));
    return `<h${depth} id="${id}"><a class="heading-anchor" href="#${id}" aria-hidden="true">#</a>${text}</h${depth}>`;
  };

  renderer.link = ({ href, title, text }) => {
    const titleAttr = title ? ` title="${escapeAttr(title)}"` : '';
    const external =
      href && /^https?:\/\//.test(href)
        ? ' target="_blank" rel="noopener noreferrer"'
        : '';
    return `<a href="${escapeAttr(href ?? '')}"${titleAttr}${external}>${text}</a>`;
  };

  return marked.parse(markdown, { renderer }) as string;
}

export function extractHeadings(markdown: string): Array<{
  id: string;
  text: string;
  level: number;
}> {
  const headings: Array<{ id: string; text: string; level: number }> = [];
  const lines = markdown.split('\n');

  for (const line of lines) {
    const match = line.match(/^(#{2,3})\s+(.+)$/);
    if (!match) continue;
    const level = match[1].length;
    const text = match[2].replace(/[*_`]/g, '').trim();
    headings.push({ id: slugify(text), text, level });
  }

  return headings;
}

function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
}

function stripHtml(text: string): string {
  return text.replace(/<[^>]+>/g, '');
}

function escapeAttr(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
